{ "id": "la-bloqueuse", "name": "La Bloqueuse", "sprite": "la-bloqueuse", "hp": 120, "speed": 160, "radius": 14, "lifetime": 10, "maxActive": 1, "behavior": "blocker", "taunt": { "radius": 260 } }
